import type { ComponentProps } from 'react';
import { OwcToggleButton } from '@one/react';

export type PocToggleButtonProps = ComponentProps<typeof OwcToggleButton>;

export const PocToggleButton: React.FC<PocToggleButtonProps> = (props) => <OwcToggleButton {...props} />;
